import { Card as AntCard } from "antd";
import type { CardProps as AntCardProps } from "antd";

interface CardProps extends AntCardProps {
  children: React.ReactNode;
}

export function Card({ children, ...props }: CardProps) {
  return <AntCard {...props}>{children}</AntCard>;
}
